module.exports = __webpack_public_path__ + "img/index3_4.699980a.png";